import { render, staticRenderFns } from "./server-list.vue?vue&type=template&id=311f3f2c&"
import script from "./server-list.vue?vue&type=script&lang=ts&"
export * from "./server-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports